import PaiAutoComplete, { OptionType } from 'features/ui/base-components/pai-auto-complete';
import { BasicActionDialog } from 'features/ui/base-dialogs';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ManualTag } from '../contact-management.types';

interface Props {
  open: boolean;
  loading: boolean;
  tags: ManualTag[];
  selectedTags: OptionType[];

  handleTagSelectionChange(event: React.ChangeEvent<HTMLInputElement>, newValue: OptionType[]): void;

  handleClose(): void;

  handleAddTags(): void;
}

const AddManualTagsDialog: React.FC<Props> = ({ open, loading, tags, selectedTags, handleTagSelectionChange, handleClose, handleAddTags }) => {
  const { t } = useTranslation();

  const options = tags.map((tag) => ({ label: tag.name, value: tag._id }));

  return (
    <BasicActionDialog
      open={open}
      loading={loading}
      dialogTitle={t('addTags')}
      maxWidth={'xs'}
      proceedButtonText={t('add')}
      handleProceed={handleAddTags}
      proceedButtonDisabled={_.isEmpty(selectedTags)}
      cancelButtonText={t('cancel')}
      handleClose={handleClose}
    >
      <PaiAutoComplete
        options={options}
        label={t('tags')}
        selected={selectedTags}
        multiple={true}
        limitTags={3}
        disableClearable={true}
        onChange={handleTagSelectionChange}
      />
    </BasicActionDialog>
  );
};

export default AddManualTagsDialog;
